<template>
  <li class="nav-item rounded" :class="fontSizeClass">
    <!-- If activeClassFunction is provided, we override the default URL matching logic of router-link -->
    <!-- and delegate the determination of the active state to the custom activeClassFunction -->
    <router-link v-if="activeClassFunction" :to="to" :class="activeClass">
      <slot />
    </router-link>
    <!-- Otherwise, we use the default behavior of the router-link component -->
    <!-- which determines the active state based on URL matching -->
    <router-link v-else class="nav-link" :to="to" :exact="exact" active-class="active">
      <slot />
    </router-link>
  </li>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'UeNavItem',
  props: {
    to: {
      type: [String, Object],
      required: false,
      default: null,
    },
    size: {
      type: String as PropType<'sm' | 'md' | 'lg'>,
      required: false,
      default: 'md',
    },
    exact: {
      type: Boolean,
      required: false,
      default: false,
    },
    // Custom function that determines if the navigation item is active
    // When provided, it overrides the default URL matching logic of vue-router
    activeClassFunction: {
      type: Function as PropType<() => boolean>,
      required: false,
    },
  },
  computed: {
    // Applies the 'active' class based on the result of activeClassFunction
    activeClass() {
      return {
        'nav-link': true,
        active: this.activeClassFunction(),
      }
    },
    fontSizeClass() {
      return {
        'fs-sm': this.size === 'sm',
        'fs-md': this.size === 'md',
        'fs-lg': this.size === 'lg',
      }
    },
  },
})
</script>

<style lang="sass" scoped>
// Would be nice to have a hover effect on the nav item.
// Designs for that are TBD.
// .nav-item\
//   &:hover
//     background-color: var(--gray-700)
</style>
